import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true
    }
  ],
  standalone: false
})
export class CheckboxComponent implements ControlValueAccessor {
  
  @Input() label?: string;
  @Input() control!: FormControl;
  @Output() valueChange: EventEmitter<boolean> = new EventEmitter();

  private onChange = (value: any) => {};
  private onTouched = () => {};

  constructor() {}

  writeValue(value: any): void {
    if (this.control && value !== this.control.value) {
      this.control.setValue(value, { emitEvent: false });
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
    this.control.valueChanges.subscribe(value => {
      this.valueChange.emit(value);
    });
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.control.disable() : this.control.enable();
  }

  handleCheckboxChange(event: any) {
    const checked = event.target.checked;
    this.onChange(checked);
    this.onTouched();
  }
}
